import { Component, OnDestroy, OnInit } from "@angular/core";

import { Certification } from "./../../shared/models/products/certification";
import { Exam } from "./../../shared/models/products/exam";

import { PurchaseStateService } from "./../../shared/services/purchase-state.service";
import { AuthService } from "./../../../auth/auth.service";
import { IPurchase } from "../../shared/models/purchase";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-confirmation",
  templateUrl: "./confirmation.component.html",
})
export class ConfirmationComponent implements OnInit, OnDestroy {
  isExamPurchase: boolean;
  examInfo = {
    isExamPurchase: false,
    schedulingLink: "",
    eligibilityEndDate: "",
  };
  ccpInfo = {
    isCcpPurchase: false,
    isAuditRequired: false,
    isAEC: false,
    requiredByDate: new Date(),
  };
  purchase: IPurchase;
  private destroy$ = new Subject<void>();

  constructor(
    private purchaseState: PurchaseStateService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.purchase = this.purchaseState.getCompletedPurchase();
    this.getExamInfo();
    this.getCcpInfo();
    this.authService.refreshToken().pipe(takeUntil(this.destroy$)).subscribe();
  }

  private getExamInfo() {
    const exam = <Exam>this.purchase.products.find((p) => p.constructor === Exam);
    if (!exam) {return;}

    this.examInfo.isExamPurchase = true;
    (this.examInfo.schedulingLink = exam.schedulingLink),
      (this.examInfo.eligibilityEndDate = exam.eligibilityEndDate);
  }

  private getCcpInfo() {
    const certification = <Certification>(
      this.purchase.products.find((p) => p.constructor === Certification)
    );
    if (!certification) {return;}
    this.ccpInfo.isCcpPurchase = true;
    this.ccpInfo.isAuditRequired = certification.isAuditRequired;
    this.ccpInfo.isAEC = certification.isAEC;
    this.ccpInfo.requiredByDate = this.calcCcpAuditDate();
  }

  private calcCcpAuditDate() {
    const dat = new Date();
    dat.setDate(dat.getDate() + 14);
    return dat;
  }

  get paymentMethodLabel(): string {
    if (this.purchase.paymentMethod === "V") {
      return "Voucher";
    }
    if (this.purchase.paymentMethod === "CP") {
      return "No Payment Required";
    }
    if (this.purchase.paymentMethod === "CH") {
      return "Check";
    }
    if (this.purchase.paymentMethod === "CC") {
      return "Credit Card";
    }
    if (this.purchase.paymentMethod === "ACH") {
      return "E-Check";
    }
    return this.purchase.paymentMethod;
  }

  isNoMoneyDue(): boolean {
    if (this.purchase.total === 0) {return true;}
    else {return false;}
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
